import CustomersBySellerId from './queries/customer/CustomersBySellerId.gql';
import CustomerBySellerId from './queries/customer/CustomerBySellerId.gql';
import CreateSeller from './queries/customer/CreateSeller.gql';
import ValidateInvite from './queries/customer/ValidateInvite.gql';
import isNewAccount from './queries/customer/isNewAccount.gql';
import GetOrGenerateOptoutURLByCustomerId from './queries/customer/GetOrGenerateOptoutURLByCustomerId.gql';
import FindSellerById from './queries/seller/FindSellerById.gql';
import SaveSeller from './queries/seller/SaveSeller.gql';
import CheckSellerCPF from './queries/seller/CheckSellerCPF.gql';
import CheckSellerIdERPAndAlternateId from './queries/seller/CheckSellerIdERPAndAlternateId.gql';
import Auth0UserById from './queries/auth0/Auth0UserById.gql';
import UpdateTermsOfUseBySellerId from './queries/customer/UpdateTermsOfUseBySellerId.gql';
import FindPeople from './queries/person/FindPeople.gql';
import PersonOptOut from './queries/person/PersonOptOut.gql';
import PeopleBySituation from './queries/person/PeopleBySituation.gql';
import SituationCount from './queries/person/SituationCount.gql';
import FindCatalogueBySellerIdAndType from './queries/catalogue/FindCatalogueBySellerIdAndType.gql';
import FindAllTemplateCatalogue from './queries/template-catalogue/FindAllTemplateCatalogue.gql';

export {
  CustomersBySellerId,
  CustomerBySellerId,
  FindSellerById,
  SaveSeller,
  CheckSellerCPF,
  CheckSellerIdERPAndAlternateId,
  Auth0UserById,
  ValidateInvite,
  CreateSeller,
  UpdateTermsOfUseBySellerId,
  FindPeople,
  PersonOptOut,
  PeopleBySituation,
  SituationCount,
  isNewAccount,
  GetOrGenerateOptoutURLByCustomerId,
  FindCatalogueBySellerIdAndType,
  FindAllTemplateCatalogue,
};
